import React, { useReducer, useEffect, useState } from 'react';

import './Stamp.refund.scss';
import { ProfileQL } from '../../models/Profile';
import { AmazonOrderBinder } from '../../models/Orders';
import { SearchOrderBinded } from '../../models/Orders_v2';
import { BillBase, BillReceptor, BillConceptos, BillRelacionados, Bill, FiscalpopCFDI } from '../../models/Factura';
import Button from '../Forms/Button';
import Select from '../Forms/Select';
import Input from '../Forms/Input';
import { calculateTotalFromConcepts } from '../../services/calculations.cfdi';
import { numberToCurrencyString } from '../../services/formatting';
import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import { REGIMEN_OPTIONS } from '../../utils/regimen';
import { refundToConceptos } from '../../utils/orders/refund.toConceptos';
import { fiscalpopApi } from '../../services/fiscalpopApi';


function cfdiReducer(state: any, action: { type: 'receptor' | 'conceptos' | 'comprobante' | 'relacionados'; payload: BillBase | BillReceptor | BillConceptos[] | BillRelacionados }): Bill {
    switch (action.type) {
        case 'receptor':
            const receptor = Object.assign({}, state.receptor, action.payload as BillReceptor);
            state.receptor = receptor;
            return Object.assign({}, state);
        case 'conceptos':
            state.conceptos = action.payload as BillConceptos[];
            console.log('CFDI Reducer, conceptos: ', state);
            return Object.assign({}, state);
        case 'comprobante':
            console.log('cfdiReducer (COMPROBANTE): ', action.payload);
            return Object.assign({}, state, action.payload as BillBase)
        case 'relacionados':
            const cfdiRelacionados = Object.assign({}, state.cfdiRelacionados || {}, action.payload as BillRelacionados);
            state.cfdiRelacionados = cfdiRelacionados;
            return Object.assign({}, state);
        default:
            return state;
    }
}

interface RefundProps {
    orderBilled: SearchOrderBinded,
    currentUser: ProfileQL,
    handleManualOverride: () => void,
    updateBinderFromRefund: (orderBinder: SearchOrderBinded) => void
}

function StampRefund({ orderBilled, currentUser, handleManualOverride, updateBinderFromRefund }: RefundProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [cfdiBilled, setCfdiBilled] = useState<FiscalpopCFDI>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [cfdi, assignSetCfdi] = useReducer(cfdiReducer, {
        fecha: new Date().toJSON(),
        serie: 'REF',
        folio: '01',
        formaPago: '',
        metodoPago: 'PUE',
        lugarExpedicion: currentUser.fiscalpopProfile.lugarExpedicion || '',
        tipoDeComprobante: 'E',
        receptor: {
            nombre: '',
            rfc: '',
            usoCFDI: 'S01',
            regimen: '',
            zip: '',
            email: ''
        },
        cfdiRelacionados: {
            tipoRelacion: '01',
            uuids: [orderBilled.binder.billUUID]
        },
        conceptos: [],
    } as Bill);

    const [stampCfdi] = useMutation(graphqlSchema.FISCALPOP.CFDI.setRefundToStamp, {
        onCompleted: ({ setRefundToStamp }: { setRefundToStamp: AmazonOrderBinder }) => {
            console.log('Refund Stamped CFDI: ', setRefundToStamp);
            sharedToasterSubject.next({ type: 'confirm', message: 'Se emitió la factura correctamente' });
            console.log(`Refund Update Binder: `, Object.assign({}, orderBilled, { binder: setRefundToStamp }))
            updateBinderFromRefund(Object.assign({}, orderBilled, { binder: setRefundToStamp }));
        },
        onError: (e) => {
            setIsSubmitting(false);
            console.log(`setRefundToStamp e.graphQLErrors[0]: `, e.graphQLErrors[0]);
            const errMessage = e.graphQLErrors[0]?.message || 'Error al generar factura, revise datos de receptor y claves de producto';
            sharedToasterSubject.next({ type: 'error', message: errMessage, clickToClose: true });
        }
    });

    useEffect(() => {
        if (!!orderBilled && !!orderBilled.binder && !!currentUser && !!currentUser.amazonProfile) {
            console.log(`<UE> Fetch bill Stamp Refund for UUID`, orderBilled.binder.billUUID)
            fiscalpopApi.cfdi.findByUuid(orderBilled.binder.billUUID)
                .then((cfdiResponse: FiscalpopCFDI[]) => {
                    console.log('CFDI: ', cfdiResponse);
                    if (cfdiResponse[0]) {

                        setCfdiBilled(cfdiResponse[0]);
                        const comprobanteChange: BillBase = {
                            formaPago: cfdiResponse[0].json["@"].FormaPago,
                            lugarExpedicion: cfdiResponse[0].json["@"].LugarExpedicion,
                            metodoPago: 'PUE',
                            tipoDeComprobante: 'E'
                        }
                        const receptorChange = {
                            nombre: cfdiResponse[0].json["cfdi:Receptor"]["@"].Nombre,
                            rfc: cfdiResponse[0].json["cfdi:Receptor"]["@"].Rfc,
                            usoCFDI: cfdiResponse[0].json["cfdi:Receptor"]["@"].UsoCFDI,
                            regimen: cfdiResponse[0].json["cfdi:Receptor"]["@"].RegimenFiscalReceptor || '',
                            zip: cfdiResponse[0].json["cfdi:Receptor"]["@"].DomicilioFiscalReceptor || '',
                            email: cfdiResponse[0].email || '',
                        }
                        assignSetCfdi({ type: 'comprobante', payload: comprobanteChange });
                        assignSetCfdi({ type: 'receptor', payload: receptorChange });
                        const refundConceptos = refundToConceptos(orderBilled, cfdiResponse[0]);
                        assignSetCfdi({ type: 'conceptos', payload: refundConceptos });
                        assignSetCfdi({
                            type: 'relacionados', payload: {
                                tipoRelacion: '01',
                                uuids: [orderBilled.binder.billUUID]
                            }
                        });
                    }
                })

        }
    }, [orderBilled, currentUser]);

    const dateOffsetOptions = [
        { value: 0, label: 'Hoy mismo' }
    ];

    const _emptyOnChange = () => { }

    const submitCFDI = () => {
        console.log('CFDI: ', cfdi);
        setIsSubmitting(true);
        stampCfdi({
            variables: {
                cfdi,
                refundIds: [orderBilled.order.orderId],
                orderId: orderBilled.order.orderId
            }
        })
    }

    // RENDER METHODS
    // ================

    const renderTotals = () => {
        const { subtotal, iva, total } = calculateTotalFromConcepts(cfdi.conceptos);
        return (
            <div className="cfdiTotal">
                <p className="_subtotal">
                    <b>Subtotal:</b> $ {numberToCurrencyString(subtotal)}
                </p>
                <div className="_taxes">
                    <p><b>IVA:</b> $ {numberToCurrencyString(iva)}</p>
                </div>
                <p className="_total">
                    <b>Total: </b> $ {numberToCurrencyString(total)}
                </p>
            </div>
        )
    }

    const renderItemList = () => {
        return (
            <div className="itemList">
                <div className="lineItem header">
                    <p>
                        Producto
                    </p>
                    <p className='_unitary'>
                        Precio unitario
                    </p>
                    <p className='_keys'>
                        Clave SAT
                    </p>
                    <p className='_tax'>
                        Impuestos
                    </p>
                </div>
                {
                    cfdi.conceptos.map((concepto, i) => {
                        // Taxes =====
                        const taxes = concepto.impuestos;
                        const iva = taxes.find(t => t.type === 'iva');
                        // ===========
                        return (
                            <div className="lineItem" key={i}>
                                {
                                    concepto.claveProdServ === '78102203' ?
                                        <div className="itemShipping">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
                                            </svg>
                                            <p>
                                                {concepto.descripcion}
                                            </p>
                                        </div>
                                        :
                                        <p>
                                            {concepto.descripcion}
                                        </p>
                                }
                                <p>
                                    $ {numberToCurrencyString(concepto.valorUnitario)} <b>(x {concepto.cantidad})</b>
                                </p>
                                <div className="_keys">
                                    <p>{concepto.claveProdServ}</p>
                                    <p>{concepto.claveUnidad}</p>
                                    <p className="_isCustomized">{concepto.claveProdServ !== currentUser.amazonProfile.defaultClaveSatProdServ ? '' : '(Default)'}</p>
                                </div>
                                <div className="_taxes">
                                    <p className="_iva">
                                        <b>IVA ({iva.exento ? 'Exento' : (iva.tasa * 100).toFixed(0) + '%'}):</b> $ {numberToCurrencyString(iva.tasa * (concepto.valorUnitario))}
                                    </p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <div id="StampRefundBilled">
            <div className="stampContent">
                <div className="explain">
                    <h3>Facturar egreso (Nota de crédito)</h3>
                    <p>Los valores de la factura de egreso no pueden cambiarse ya que están asociados al total del pedido</p>
                </div>
                <div className="card billBody">
                    <div className="row three md-two">
                        <Select value={0} onChange={_emptyOnChange} disabled={true} label={'Fecha de factura'} options={dateOffsetOptions} />
                    </div>
                    <div className="row three lg-two sm-one">
                        <Input type="text" value={'(31) Intermediarios'} onChange={_emptyOnChange} label={'Forma de Pago'} placeholder="Forma de pago" disabled={true} />
                        <Input type="text" label="Método de pago" placeholder="Método de pago" value={`(PUE) Un solo Pago`} disabled={true} onChange={_emptyOnChange} />
                        <Input type="text" label="Lugar de expedición" placeholder="Lugar de expedición" value={cfdi.lugarExpedicion} onChange={_emptyOnChange} disabled={true} />
                        <div />
                    </div>
                    <div className="divider"></div>
                    <div className="row two sm-one">
                        <Input type="text" label="Razón social" placeholder="Razón social del receptor" value={cfdi.receptor.nombre} onChange={_emptyOnChange} disabled={true} />
                        <Input type="text" label="RFC" placeholder="RFC del receptor" value={cfdi.receptor.rfc} onChange={_emptyOnChange} disabled={true} />


                        <Select value={cfdi.receptor.regimen} onChange={_emptyOnChange} disabled={true} label={'Régimen'} options={REGIMEN_OPTIONS} />
                        <Input type="text" label="Código postal receptor" placeholder="Codigo postal" value={cfdi.receptor.zip} onChange={_emptyOnChange} disabled={true} />


                        <Input type="text" placeholder="" value={'(S01) Por definir'} onChange={_emptyOnChange} label={'Uso CFDI'} disabled={true} />
                        <Input type="text" label="Email" placeholder="Email del receptor" value={cfdi.receptor.email} onChange={_emptyOnChange} disabled={true} />
                    </div>
                    <div className="divider whole"></div>
                    {renderItemList()}
                    {renderTotals()}
                </div>
                <div className="actions">
                    <div className={`_FpopErrors`}>
                    </div>
                    <Button primary={true} handleClick={submitCFDI} disabled={isSubmitting || !currentUser.fiscalpopProfileStatus.modulusMatch}>
                        <span>{isSubmitting ? 'Facturando...' : 'Facturar reembolso'}</span>
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default StampRefund;